module.exports = __webpack_public_path__ + "static/assets/80e5742e351e6dc94d4fc4330953a439.png";